import React from 'react';
import Logo from '../images/logo-alt.svg';
import './footer.scss';

export default function Footer() {
  return (
    <footer className="c-footer">
      <div className="l-wrapper">
        <div className="c-footer__top">
          <img src={Logo} alt="Gotok" />
          <ul>
            <li>
              <a href="https://peckle.ai" target="_blank" rel="noreferrer">
                Peckle
              </a>
            </li>
            <li>
              <a href="/about">About</a>
            </li>
            <li>
              <a href="mailto:help@gotok.app">Contact</a>
            </li>
          </ul>
        </div>
        <div className="c-footer__bottom">
          <span>
            &copy; {new Date().getFullYear()} Gotok Technologies Limited. All
            rights reserved.
          </span>
        </div>
      </div>
    </footer>
  );
}
